import React from 'react';
import ReactDOM from 'react-dom/client';
import {ErrorBoundary} from 'react-error-boundary';

import UserSetting from "./contexts/userContext";
import SpaceSetting from "./contexts/spaceContext";

import App from "./pages/App";
import {HashRouter as Router} from "react-router-dom";

const $rootEl = document.getElementById('root')
const root = ReactDOM.createRoot($rootEl);


root.render(
    <ErrorBoundary fallback={<div>Error...</div>}>
        <Router>
            <SpaceSetting>
                <UserSetting>
                    <App />
                </UserSetting>
            </SpaceSetting>
        </Router>
    </ErrorBoundary>
);

